import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getBannerStart,
  getBannerFailed,
  getBannerSuccess,
} from "../redux/getBanner";
import { getBannerApi } from "core/http/service/homepage";

function* getBannerWork() {
  try {
    const res = yield call(getBannerApi);
    yield put({
      type: getBannerSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getBannerFailed.type,
    });
  }
}

function* watchGetBanner() {
  yield takeLatest(getBannerStart.type, getBannerWork);
}

export default function* getBannerSaga() {
  yield all([watchGetBanner()]);
}
